/**
 * Copies text to the clipboard, reporting success instead of throwing so callers
 * can toast either way. `navigator.clipboard` is undefined on insecure origins
 * and rejects when the document isn't focused, which is why this never assumes.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
